import { BaseBadge, BaseText } from "../components";

const badgeTextMapping: { [key: string]: string } = {
	pendingFulfillment: "Pending Fulfillment",
	partiallyFulfilled: "Partially Fulfilled",
	pendingApproval: "Pending Approval",
	pendingInitialApproval: "Pending Initial Approval",
	fulfilled: "Fulfilled",
	approved: "Approved",
	billed: "Billed",
	canceled: "Canceled",
	Required: "Required",
	Kit: "Kit",
	"Computer Support": "Computer Support",
	Primary: "Primary",
	"Add-on": "Add-on",
};

const getBadgeClasses = (badgeText?: string, hasIcon?: boolean) => {
	const baseClasses = `${
		hasIcon ? "px-2 py-1 gap-x-1" : ""
	} h-6 flex justify-center items-center text-xs font-inter-medium whitespace-nowrap overflow-hidden text-ellipsis rounded`;

	switch (badgeText) {
		case "Required":
			return `${baseClasses} bg-cyan-light text-cyan-dark`;
		case "Kit":
			return `${baseClasses} bg-secondary-200 text-primary-800`;
		case "Computer Support":
			return `${baseClasses} bg-yellow-light text-yellow-dark`;
		case "Lease":
			return `${baseClasses} bg-yellow-light text-yellow-dark`;
		case "Primary":
			return `${baseClasses} bg-green-light-6 text-green-dark`;
		case "Add-on":
			return `${baseClasses} bg-gray-4 text-gray-3`;
		case "In Stock":
			return `${baseClasses} bg-green-light text-green-dark`;
		case "fulfilled":
			return `px-2.5 bg-mint-50 text-mint-700 rounded-30px`;
		case "approved":
			return `px-2.5  bg-mint-50 text-mint-700 rounded-30px`;
		case "billed":
			return `px-2.5  bg-mint-50 text-mint-700 rounded-30px`;
		case "canceled":
			return ` bg-crimson-50 text-crimson-700 rounded-30px`;
		case "pendingInitialApproval":
			return `bg-aqua-50 text-aqua-800 rounded-30px`;
		case "pendingApproval":
			return `bg-[#FFF0E9] text-[#AD3E06] rounded-30px`;
		case "pendingFulfillment":
			return `bg-[#F0F4FA] text-[#326FBD] rounded-30px`;
		default:
			return `${baseClasses}`;
	}
};

const renderBadge = (
	badgeText?: string,
	textSize?: string,
	icon?: JSX.Element,
	iconPlacement?: "hasLeftIcon" | "hasRightIcon"
) => {
	const defaultTextSize = textSize || "text-xs";
	const formattedBadgeText = badgeTextMapping[badgeText || ""] || badgeText;

	return (
		<BaseBadge
			icon={icon}
			hasLeftIcon={iconPlacement === "hasLeftIcon"}
			hasRightIcon={iconPlacement === "hasRightIcon"}
			text={
				<BaseText
					color=""
					fontFamily="font-medium"
					tag="p"
					text={formattedBadgeText}
					size=""
					additionalClasses={`${defaultTextSize} ${
						icon ? "" : "px-2 py-1"
					} whitespace-nowrap overflow-hidden text-ellipsis`}
				/>
			}
			badgeContainerClasses={getBadgeClasses(
				badgeText,
				icon ? true : false
			)}
		/>
	);
};

export default renderBadge;
